import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { InvestmentMovementComponent } from './investment-movement.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
  ],
  declarations: [
    InvestmentMovementComponent,
  ],
  exports: [
    InvestmentMovementComponent,
  ],
})
export class InvestmentMovementModule { }
